import { Button, Dropdown } from "react-bootstrap";
import "./productmasterprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import editicon from "../../assets/images/edit-icon.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";
import { ReactSVG } from "react-svg";
import { Product } from "../../redux/product/productSlice";
import { MouseEventHandler } from "react";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
interface ProductProfileHeader {
  selectedProductData: Product;
  updateStatus: any;
  toggleModal: MouseEventHandler<HTMLElement>;
  toggleDuplicateModal: MouseEventHandler<HTMLElement>;
}
const ProductMasterProfileHeader = ({
  selectedProductData,
  updateStatus,
  toggleModal,
  toggleDuplicateModal,
}: ProductProfileHeader) => {
  return (
    <div className="product-master-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedProductData.productName}</h2>
      </div>
      <div className="profile-actions-box">
        <div className="edit-btn-box">
          <Button variant="primary" href="/edit-product-master">
            <i className="bi bi-pencil-square"></i> Edit
          </Button>
        </div>
        <Dropdown>
          <Dropdown.Toggle variant="link" id="dropdown-basic">
            <ReactSVG
              className="svg-box"
              wrapper="span"
              src={threedotvertical}
            />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={toggleModal}>
              <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
              Delete
            </Dropdown.Item>
            <Dropdown.Item onClick={toggleDuplicateModal}>
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={duplicateicon}
              />
              Duplicate
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default ProductMasterProfileHeader;
